module.exports = __webpack_public_path__ + "img/logo-gr-white.b8840af4.svg";